<template>
  <v-container  fluid style="margin-top:60px; margin-bottom: 90px;" class="gray_bg_container">
      <v-container >
        <v-row style="    margin-bottom: 35px; ">
        <v-col cols="12" 
          ><center><v-img src="/img/stat_sel.png" max-height="187px" contain center></v-img
        ></center></v-col>
        
      </v-row>



      <v-row align="center" justify="center" no-gutters style="    margin-bottom: 35px; " >
  
  <v-col cols="11"  @click="$router.push({ name: 'TT_current' })"
    ><btnsqr        
          img="img/prof_btn_ico.png"
          
         
          >Статистика проміжна

        </btnsqr></v-col>
    </v-row>

    <v-row align="center" justify="center" no-gutters style="    margin-bottom: 35px; " >
  
  <v-col cols="11"  @click="/*$router.push({ name: 'TT_final' });*/$emit('pushe', {header:'Повідомлення',text:'Цей розділ стане доступним після проведення перших нарахувань.'});"
    ><btnsqr        
          img="img/prof_btn_ico.png"
         
          
          >Статистика фінальна

        </btnsqr></v-col>
    </v-row>
      
    <!-- <v-row fluid>
        <v-col cols="12">
            <v-btn rounded class="primary_button" @click.native="write=true" style="word-wrap:break-all;height: 90px !important;"  v-html="$t('btn1')"></v-btn><br>
        </v-col>
    </v-row><br><br><br><br>
     <v-row fluid>
       <v-col cols="12">
      <v-btn rounded class="primary_button"  @click.native="write_tp=true" style="word-wrap:break-all;height: 90px !important;" v-html="$t('btn2')"></v-btn><br>
      </v-col>
    </v-row><br> -->
    
    <!--
    <v-row fluid>
       <v-col cols="12">
      <v-btn rounded class="primary_button" @click.native="write_tp=true" v-html="$t('btn3')"></v-btn><br>
      </v-col>
    </v-row>

      <v-row fluid>
       <v-col cols="12">

    <p  style="text-align: center; " class="akrobold" >Ще залишилися питання? <br>Телефонуй на гaрячу лінію, з понеділка по п'ятницю
                 <h1><p style="text-align: center; " class="akrobold" ><a href="tel:0800330938">0-800-330-938</a></p></h1>
                 <p style="text-align: center;  " class="akrobold">з 10<sup>00</sup> до 17<sup>00</sup> у робочі дні</p>
                 </v-col>
    </v-row> -->
      </v-container>

 
      <v-dialog v-model="faq">
      <v-card>
        <v-card-title class=""  style="background-color:orange;color:white;z-index:1;margin-bottom:20px;justify-content:center;text-align:center;">
          <!-- header -->
          {{$t('h_faq')}}  
        </v-card-title>
       
        <v-card-text>
          <v-expansion-panels
        :accordion="accordion"
        :popout="popout"
        :inset="inset"
        :multiple="multiple"
        :focusable="focusable"
        :disabled="disabled"
        :readonly="readonly"
        :flat="flat"
        :hover="hover"
        :tile="tile"
      >
        <v-expansion-panel
          v-for="(faq,i) in faqs"
          :key="i"
        >
          <v-expansion-panel-header><b>{{faq.header}}</b></v-expansion-panel-header>
          <v-expansion-panel-content v-html="faq.text" style="padding:15px;">
            
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <span class="link" text @click="faq = false">   {{$t('close')}} </span>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="write">
      <v-card  class="rounded-lg simple_card" >
        <v-card-title   style="z-index:1;margin-bottom:20px;justify-content:center;text-align:center;">
          <!-- header -->
          {{$t('h_write')}}  
          <div @click="write = false" class="close_dialog"></div>
        </v-card-title>
       
        <v-card-text>
          <v-row align="top" justify="center">
            <v-select
            class="rounded-lg"
            style="border-radius: 35px !important;"
            :items="items"
             item-text="text"
            label="Оберіть точку"
             item-value="cd_id"
            solo
            v-model=select
          ></v-select>
          </v-row>
          <v-row align="top" justify="center">
           
         <v-col cols="12" sm="4" md="4">
             <v-textarea
            outlined
            name="input-7-4"
            label=""
            value="Повідомлення"
            v-model=push1

          ></v-textarea>

          <v-btn primary large block type="submit" @click="send_push1"  class="btn_new">Надіслати</v-btn>
         </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <span class="link" text @click="write = false">   {{$t('close')}} </span>
        </v-card-actions> -->
      </v-card>
      <div class="popup_bottom_robot"></div>
    </v-dialog>

    <v-dialog v-model="write_tp">
      <v-card class="rounded-lg simple_card" >
        <v-card-title   style="z-index:1;margin-bottom:20px;justify-content:center;text-align:center;">
          <!-- header -->
          {{$t('h_contact')}}  
          <div @click="write_tp = false" class="close_dialog"></div>
        </v-card-title>
       
        <v-card-text>
          
          <v-row align="top" justify="center">
           
         <v-col cols="10" sm="4" md="4">
             <v-textarea
            outlined
            name="input-7-4"
            label=""
            value="Повідомлення"
            v-model=push_all
          ></v-textarea>

          <v-btn primary large block type="submit" @click="send_push_all"  class="btn_new">Надіслати</v-btn>
         </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <span class="link" text @click="write_tp = false">   {{$t('close')}} </span>
        </v-card-actions> -->
      </v-card>
      <div class="popup_bottom_robot"></div>
    </v-dialog>
    </v-container>
</template>

<script>
import btnrnd from "../components/btnrnd.vue";
// eslint-disable-next-line no-unused-vars
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import { API_LOCATION } from "../../config";
import Btnsqr from "../components/btnsqr.vue";
export default {
  name: "Info",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    btnrnd,Btnsqr
  },
  data: () => ({
    faq:false,
    write:false,
    write_tp:false,
    contact:false,
    items:[],
    
        accordion: false,
    popout: false,
    inset: false,
    multiple: false,
    disabled: false,
    readonly: false,
    focusable: false,
    flat: false,
    hover: false,
    tile: false, 
    req_tp:'',
    req_tp_tp:'',
    select:'',
    push_all:'',
    push1:'',
        apiurl:API_LOCATION,
  }),
  computed: {
    task1: function () {
      return this.cards.filter((i) => i.type == "1");
    },
    task2: function () {
      return this.cards.filter((i) => i.type == "2");
    },
    task3: function () {
      return this.cards.filter((i) => i.type == "3");
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    authStatus: function () {
      return this.$store.getters.authStatus;
    },
    page_title: function () {
      return this.$store.getters.page_title;
    },
    fname: function () {
      return this.$store.getters.fname;
    },
    lname: function () {
      return this.$store.getters.lname;
    },
    points: function () {
      return this.$store.getters.points;
    },
    avatar: function () {
      return this.$store.getters.avatar;
    },
      title() {
        return this.$t('title')
      },
      faqs(){
        
        return[
          
          {'header':this.$t('q1'),'text':this.$t('a1')},
          {'header':this.$t('q2'),'text':this.$t('a2')},
          {'header':this.$t('q3'),'text':this.$t('a3')},
          {'header':this.$t('q4'),'text':this.$t('a4')},
          {'header':this.$t('q5'),'text':this.$t('a5')},
          {'header':this.$t('q6'),'text':this.$t('a6')},
          {'header':this.$t('q7'),'text':this.$t('a7')},
          {'header':this.$t('q8'),'text':this.$t('a8')},
          {'header':this.$t('q9'),'text':this.$t('a9')},
          {'header':this.$t('q10'),'text':this.$t('a10')}
        ]},
  },
  watch:{
      title: function(){
        this.$store.dispatch("page_title_set", this.title);
      }
  },
  mounted() {
     
  },
  created() {
    this.$store.dispatch("page_title_set", this.title);
    this.$store.dispatch("profileset");

    this.get_cd();
  },
  methods:{
        save_request: function(){

            axios.post(this.apiurl,  { data: 'component_data',action: 'tpq_create', 'question':this.req_tp },{ headers: { 'content-type': 'application/x-www-form-urlencoded' } })
         .then(resp =>{
           
         if(resp.data=='OK'){ 
            //this.$store.commit('setSnack', 'Запит надіслано!')
            alert('Запит надіслано!');
            this.write=false;
            this.req_tp='';
            //this.$router.push({ name: 'Profile'})
          }
          })
            
        },

        save_request_tp: function(){

            axios.post(this.apiurl,  { data: 'component_data',action: 'tpq_create_tp', 'question':this.req_tp_tp },{ headers: { 'content-type': 'application/x-www-form-urlencoded' } })
         .then(resp =>{
           
         if(resp.data=='OK'){ 
            //this.$store.commit('setSnack', 'Запит надіслано!')
            alert('Запит надіслано!');
            this.write_tp=false;
            this.req_tp_tp='';
            //this.$router.push({ name: 'Profile'})
          }
          })
            
        },

        get_cd: function () {
     
      this.isLoading=true;
      axios
      .post(
        API_LOCATION,
        {
          
          action: "cd_list" 
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
        
      
      
        console.log(resp.data); 
        this.items=resp.data;
        
      });
      
    },

    send_push1:function () {
     
      this.isLoading=true;
      axios
      .post(
        API_LOCATION,
        {
          
          action: "send_push1",
          cd_id:this.select,
          text:this.push1
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
      
        console.log(resp.data); 
       

       if(resp.data=='bad_cd')
       {
         alert('Оберіть точку');
       }
       else if(resp.data=='bad_text')
      {
       
        alert('Введіть текст');
      }
      else
      {
         alert('Повідомлення надіслано');
          this.write=false;
          this.push1='';
      }
         
      });
      
    },

    send_push_all:function () {
     
      this.isLoading=true;
      axios
      .post(
        API_LOCATION,
        {
          
          action: "send_push_all",
          
          text:this.push_all
          
        },
        { headers: { "content-type": "application/x-www-form-urlencoded" } }
      )
      .then((resp) => {
      
        console.log(resp.data); 
       

       if(resp.data=='bad_cd')
       {
         alert('Оберіть точку');
       }
       else if(resp.data=='bad_text')
      {
       
        alert('Введіть текст');
      }
      else
      {
         alert('Повідомлення надіслано');
          this.write_tp=false;
          this.push_all='';
      }
         
      });
      
    },

    }
};
</script>


<i18n>
{
  
  "ua":{
      "title":"Комунікація",
      "btn1":"Надіслати повідомлення  одній точці",
      "btn2":"Надіслати повідомлення  всім точкам",
      "btn3":"Надіслати повідомлення <br>торговому представнику",
      "close":"Закрити",
      "h_write":"Надіслати повідомлення одній точці",
      "h_contact":"Надіслати повідомлення ВСІМ",
      "h_faq":"Відповіді на часті питання",
      "q1":"Чи можу я змінити номер телефону для участі у програмі?",
      "a1":"Так, це можливо. Зверніться, будь ласка, до Вашого Торгового Представника.",

      "q2":"Яку максимальну кількість балів я можу отримати за місяць?",
      "a2":"Максимальна кількість балів, яку можна отримати, залежить від типу Вашого контракту: <br>К300 – 300 балів, <br>К400 – 400 балів,<br>К500 – 500 балів. <br>Виконання екстра завдань дає можливість заробити додаткові бали в  доповнення до стандартної кількості балів контракту.",
      
      "q3":"Я зробив(-ла) помилку при виборі асортименту для участі. Чи можу я його змінити?",
      "a3":"Зміна асортименту для участі доступна раз на один квартал. Для уточнення інформації зверніться, будь ласка, до Вашого Торгового Представника.",

      "q4":"Чи зберігаються на наступний місяць мої накопичені бали?",
      "a4":"Так, зберігаються.",

      "q5":"Мені не нарахували бали за завдання «Фото вітрини» та «Мій товарний запас», у чому причина?",
      "a5":"Усі фото перевіряються вручну модератором, тому модерація може займати декілька днів. Точну інформацію Ви можете дізнатись у свого Торгового Представника.",

      "q6":"Які критерії враховуються при перевірці завдання «Фото вітрини»?",
      "a6":"Критеріями перевірки є  наявність усіх SKU, (відповідно до обраного асортименту) та правильність їх викладки.",

      "q7":"Якщо я беру участь в програмі як мережева торгова точка, скільки SKU має бути на фото вітрини?",
      "a7":"На фото вітрини має бути 32 SKU із актуального асортименту програми (актуальний асортимент уточнюйте у Вашого Торгового Представника).",

      "q8":"Які критерії враховуються при перевірці завдання «Мій товарний запас»?",
      "a8":"Критерієм перевірки є наявність на фото блоку кожного SKU із списку, наведеного у завданні, з нанесеним унікальним кодом.",

      "q9":"Я ввів(-ла) неправильний номер картки Fishka, чи можна його змінити?",
      "a9":"Так, змінити номер карти Fishka можна. Для цього достатньо звернутися у службу тех. підтримки iTeam.",

      "q10":"Як довго чекати на замовлені емоції?",
      "a10":"Поповнення мобільного рахунку та нарахування балів Fishka відбувається одразу (15-20 хвилин) автоматично, замовлені електронні сертифікати «Сільпо», «Єва» та «Розетка» з'являються у застосунку одразу."


      

  }
}
</i18n>